import { FC } from 'react'

import { IconClock, Inspector, GreyGrey70 } from '@sequencehq/core-components'

import { type ActivityLogDiffFn } from '../ActivityLogItem/activityLogDiff.helpers'
import { ActivityEntityType } from '../types'
import { InspectorContent } from './InspectorContent'

export const ActivityLogsInspectorItem: FC<{
  enabled: boolean
  entityId: string
  entityType: ActivityEntityType
  /** When provided, only show activity log items whose diff changes include at least one of these field names */
  filterFields?: Set<string>
  /** Override the activity log item title */
  itemTitle?: string
  /** Custom diff function for domain-specific formatting */
  diffFn?: ActivityLogDiffFn
}> = ({ enabled, entityId, entityType, filterFields, itemTitle, diffFn }) => {
  if (!enabled) return null

  return (
    <Inspector.IconItem
      data-testid="activity-log.inspector.item"
      tooltip="Activity log"
      content={
        <InspectorContent
          entityId={entityId}
          entityType={entityType}
          filterFields={filterFields}
          itemTitle={itemTitle}
          diffFn={diffFn}
        />
      }
      icon={<IconClock color={GreyGrey70} />}
    />
  )
}
